import GameList from "../Models/GameList";
import { Global } from "../Shared/Global";
import ThirdGameItem from "./ThirdGameItem";
import Constant from "../Shared/Constant";
import UIManager from "../Shared/UIManager";
import AudioManager from "../Shared/AudioManager";
import Player from "../Models/Player";
const i18n = require("LanguageData");
const { ccclass, property } = cc._decorator;

@ccclass
export default class TopGamesLayer extends cc.Component {
    @property(cc.ToggleContainer)
    toggleContainer: cc.ToggleContainer = null

    @property(cc.Prefab)
    pfbGameItem: cc.Prefab = null

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null

    @property(cc.Widget)
    wgtScrollView: cc.Widget = null

    @property(cc.Layout)
    layoutItems: cc.Layout = null

    @property(cc.Node)
    nodeGirl: cc.Node = null

    @property(cc.Node)
    nodeGameTypes: cc.Node = null

    @property(cc.Node)
    nodeTrangle: cc.Node = null

    @property(cc.Animation)
    aniTopGames: cc.Animation = null

    private _movedLeft: boolean = false
    private _scrollStartPos: cc.Vec2 = cc.v2(0, 0)
    private _oldGirlPosX: number = 0
    private _oldItemsPosX: number = 0
    private _willShowItems: boolean = true
    private _topGameItems = []
    private _oftenGameItems = []

    onLoad() {
        this.layoutItems.node.removeAllChildren()

        if (cc.winSize.width / cc.winSize.height > 2) {
            this.wgtScrollView.right += Constant.BangLength
        }

        cc.director.on(Global.UserEvent.GameListChanged, this.createNodeItems, this)
        cc.director.on(Global.UserEvent.AddOftenGameConfig, this.onAddOftenGameConfig, this)
    }

    onEnable() {
        if (GameList.serverData) {
            this.showItems(this._topGameItems)
        }
    }

    onDisable() {
        this.toggleContainer.toggleItems[0].isChecked = true
    }

    onDestroy() {
        cc.director.off(Global.UserEvent.GameListChanged, this.createNodeItems, this)
        cc.director.off(Global.UserEvent.AddOftenGameConfig, this.onAddOftenGameConfig, this)
    }

    onBtnClick(touchEvent, userData) {
        if (userData === "sanjiaoxing") {
            AudioManager.playSound("show")
            if (touchEvent.target.scaleX > 0) {
                this.moveToLeft()
            } else {
                this.moveToRight()
            }
        }
    }

    createNodeItems() {
        if (!GameList.serverData) {
            return
        }

        // 最近常玩游戏    
        let oftenGames = JSON.parse(cc.sys.localStorage.getItem("OftenGames") || "[]")

        oftenGames.forEach(item => {
            this._oftenGameItems.push(this.createGameItem(item.gameConfig))
        });

        let topGamesCfg = GameList.getGameListByType("")
        this._topGameItems = this.createGameItems(topGamesCfg["twoLevelList"] || [])
        this.showItems(this._topGameItems)
    }

    onAddOftenGameConfig(gameConfig) {
        this._oftenGameItems.push(this.createGameItem(gameConfig))
    }

    onScrollViewEvent(scrollview, eventType) {
        if (eventType === cc.ScrollView.EventType.SCROLL_BEGAN) {
            this._scrollStartPos = scrollview.content.position
            return
        }

        if (eventType === cc.ScrollView.EventType.SCROLLING && scrollview.content.x < this._scrollStartPos.x && scrollview.content.x < 0 && !this._movedLeft) {
            this.moveToLeft()
        } else if (eventType === cc.ScrollView.EventType.SCROLLING && scrollview.content.x > this._scrollStartPos.x && scrollview.content.x > 0 && this._movedLeft) {
            this.moveToRight()
        }
    }

    onSelectToggle(toggle: cc.Toggle) {
        AudioManager.playSound("toggle")

        if (toggle.node.name === "top") {
            if (this._willShowItems) {
                this.showItems(this._topGameItems)
            } else {
                this._willShowItems = true
            }
        } else if (toggle.node.name === "often") {
            if (!Player.isLogedIn()) {
                this._willShowItems = false
                this.toggleContainer.toggleItems[0].isChecked = true
                return
            }

            if (this._oftenGameItems.length === 0) {
                UIManager.showToastUI(i18n.t('BasicsJS.play_game'), Global.ToastType.Warnning)
                this._willShowItems = false
                this.toggleContainer.toggleItems[0].isChecked = true
                return
            }

            this.showItems(this._oftenGameItems)
        }
    }

    private createGameItem(gameConfig) {
        let node = cc.instantiate(this.pfbGameItem)
        let gameItem = node.getComponent(ThirdGameItem)
        let button = node.getChildByName("node").addComponent(cc.Button)
        let clickEventHandler = new cc.Component.EventHandler()

        node.width = this.layoutItems.node.height * 0.49
        node.height = this.layoutItems.node.height * 0.49
        gameItem.urlImgPrefix = GameList.serverData["imgPrefix"]
        gameItem.gameConfig = gameConfig
        clickEventHandler.target = cc.find("Canvas/gameNode")
        clickEventHandler.component = "HallUI"
        clickEventHandler.handler = "onGameItemClick"
        button.clickEvents.push(clickEventHandler)
        button.transition = cc.Button.Transition.SCALE
        button.zoomScale = 0.9
        button.node["gameConfig"] = gameItem.gameConfig

        return gameItem
    }

    private createGameItems(gamesCfg: []) {
        let gameItems = []

        gamesCfg.forEach(item => {
            gameItems.push(this.createGameItem(item))
        });

        return gameItems
    }

    private showItems(gameItems) {
        this.layoutItems.node.removeAllChildren()

        gameItems.forEach(item => {
            item.node.parent = this.layoutItems.node
        });

        // 动画效果
        this.layoutItems.node.x = 0
        this.layoutItems.enabled = true
        this.layoutItems.updateLayout()
        this.layoutItems.enabled = false
        // 解决content size小于scrollview size时，不能拖动的问题
        this.scrollview.content.width = Math.max(this.scrollview.content.width, this.scrollview.node.width + 10)
        let delay = 0
        this.layoutItems.node.children.forEach(node => {
            let oldPos = node.position
            node.position = cc.v2(oldPos.x + 1000, oldPos.y)
            node.stopAllActions()
            node.runAction(cc.sequence(cc.delayTime(delay), cc.moveTo(0.2, cc.v2(oldPos.x - 50, oldPos.y)).easing(cc.easeSineOut()), cc.moveTo(0.15, oldPos).easing(cc.easeSineInOut())))
            delay += 0.05
        })
    }

    private moveToLeft() {
        if (this._oldGirlPosX === 0) {
            this._oldGirlPosX = this.nodeGirl.x
            this._oldItemsPosX = this.scrollview.node.x
        }

        this.nodeTrangle.scaleX *= -1
        this._movedLeft = true
        this.nodeGirl.stopAllActions()
        this.scrollview.node.stopAllActions()
        this.nodeGirl.runAction(cc.spawn(cc.moveTo(0.25, cc.v2(-this.nodeGirl.width / 2 - this.nodeGirl.parent.width * this.nodeGirl.anchorX, this.nodeGirl.y)).easing(cc.easeSineOut()), cc.fadeOut(0.25)))
        let scrPosition = this.scrollview.node.parent.convertToNodeSpaceAR(this.nodeGameTypes.convertToWorldSpaceAR(cc.v2(this.nodeGameTypes.width * this.nodeGameTypes.anchorX + Constant.BangLength, 0)))
        this.scrollview.node.runAction(cc.moveTo(0.25, cc.v2(scrPosition.x, this.scrollview.node.y)).easing(cc.easeSineOut()))
    }

    private moveToRight() {
        this.nodeTrangle.scaleX *= -1
        this._movedLeft = false
        this.nodeGirl.stopAllActions()
        this.scrollview.node.stopAllActions()
        this.nodeGirl.runAction(cc.spawn(cc.moveTo(0.25, cc.v2(this._oldGirlPosX, this.nodeGirl.y)).easing(cc.easeSineOut()), cc.fadeIn(0.25)))
        this.scrollview.node.runAction(cc.moveTo(0.25, cc.v2(this._oldItemsPosX, this.scrollview.node.y)).easing(cc.easeSineOut()))
    }
}
